class SiteTitles {
    constructor(element) {
        this.el = element;
        this.split_lines();
        this.observe();
    }

    split_lines() {
        const containers = document.querySelectorAll("[data-split-line]");

        containers.forEach((el) => {
            el.style.visibility = "hidden"; // hide before processing

            el.innerHTML = el.textContent.replace(/\S+/g, "<n>$&</n>");
            const words = Array.from(el.querySelectorAll("n"));

            let currentTop = 0;
            let lines = [[]];

            words.forEach((word) => {
                const rectTop = word.getBoundingClientRect().top;
                if (currentTop === 0) currentTop = rectTop;

                if (Math.abs(rectTop - currentTop) > 1) {
                    lines.push([]);
                    currentTop = rectTop;
                }
                lines[lines.length - 1].push(word);
            });

            el.innerHTML = "";
            lines.forEach((line, index) => {
                const wrapper = document.createElement("span");
                wrapper.classList.add("split-line");
                wrapper.style.setProperty("--delay", `${index * 0.1}s`);

                line.forEach((word) => {
                    wrapper.appendChild(word);
                    wrapper.appendChild(document.createTextNode(" "));
                });

                el.appendChild(wrapper);
            });

            el.style.visibility = "visible"; // show only after fully processed
            el.classList.add("processed");
        });
    }

    observe() {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    }
                });
            },
            {
                threshold: 0.6,
            },
        );

        document.querySelectorAll("[data-split-line]").forEach((el) => {
            observer.observe(el);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-split-line]").forEach((el) => {
        new SiteTitles(el);
    });
});
